var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ag-grid-vue',{staticClass:"ag-theme-alpine grid",attrs:{"columnDefs":_vm.columnDefs,"rowData":_vm.rowData},on:{"filter-changed":_vm.onSortChanged,"grid-ready":_vm.onGridReady}})}
var staticRenderFns = []

export { render, staticRenderFns }